import QuantityBar from '../../../../components/quantity-bar/quantity-bar'
import { formatMoney, formatCurrency } from '../../../helpers/utils'
import { useFlags } from '@equipmentshare/feature-flags'

import styles from '../../index.module.css'
import AllocatedPopover from '../../../inventory/columns/components/AllocatedPopover'
import { StorePart } from '../../../../types/storePart'
import RentalsPopover from '../../../inventory/columns/components/RentalsPopover'
import OrderedPopover from '../../../inventory/columns/components/OrderedPopover'
import OutgoingPopover from '../../../inventory/columns/components/OutgoingPopover'

export type StorePartDisplayProps = {
	item: StorePart,
}

export default function StorePartDisplay( { item }: StorePartDisplayProps ) {
	const { availableQuantity, quantity, max, threshold, partsOrderedDetails, rentalItems, openReservations, outgoingTransferDetails } = item
	const flags = useFlags()

	return (
		<div>
			<div className={styles.quantityGroup}>
				<div className={styles.row}>
					Quantity in store <span className={styles.value}>{item.inventoryLocation.name}</span>
				</div>

				<div className={styles.quantityBarContainer}>
					<div className={styles.qty}>{availableQuantity}</div>
					<QuantityBar
						max={max ?? 0}
						threshold={threshold ?? 0}
						total={availableQuantity}
					/>
				</div>

				<div className={styles.qtyList}>
					<div className={styles.qtyRow}>
						<div className={styles.qtyTitle}>
							<span className={styles.totalInInventory}>Total owned</span>
						</div>
						<div className={styles.qtyValue}>
							{quantity}
						</div>
					</div>
					<div className={styles.qtyRow}>
						<div className={styles.qtyTitle}>
							Available
						</div>
						<div className={styles.qtyValue}>
							{availableQuantity}
						</div>
					</div>
					<div className={styles.qtyRow}>
						<div className={styles.qtyTitle}>
							Allocated
						</div>
						<div className={styles.qtyValue}>
							{openReservations?.length ? <AllocatedPopover reservations={openReservations ?? []} /> : 0}
						</div>
					</div>
					<div className={styles.qtyRow}>
						<div className={styles.qtyTitle}>
							On rent
						</div>
						<div className={styles.qtyValue}>
							{rentalItems?.length ? <RentalsPopover rentals={rentalItems ?? []} /> : 0}
						</div>
					</div>
					<div className={styles.qtyRow}>
						<div className={styles.qtyTitle}>
							Ordered
						</div>
						<div className={styles.qtyValue}>
							{partsOrderedDetails?.length ? <OrderedPopover partsOrdered={partsOrderedDetails ?? []} /> : 0}
						</div>
					</div>
					<div className={styles.qtyRow}>
						<div className={styles.qtyTitle}>
							Outgoing
						</div>
						<div className={styles.qtyValue}>
							{outgoingTransferDetails?.length ? <OutgoingPopover transfers={outgoingTransferDetails ?? []} /> : 0}
						</div>
					</div>
				</div>
			</div>

			<div className={styles.group}>
				<div className={styles.costRow}>
					<div className={styles.costTitle}>
						Most recent purchase cost
					</div>
					<div className={styles.costValue}>
						{item.cost ? formatCurrency( item.cost.toString() ) : 'N/A'}
					</div>
				</div>

				{ flags.enableTswWeightedAverageCost && (
					<div className={styles.costRow}>
						<div className={styles.costTitle}>
							Weighted average cost
						</div>
						<div className={styles.costValue}>
							{item.weightedAverageCost ? formatMoney( item.weightedAverageCost ) : 'N/A'}
						</div>
					</div>
				) }

				<div className={styles.costRow}>
					<div className={styles.costTitle}>
						Total value in inventory
					</div>
					<div className={styles.costValue}>
						{formatCurrency( item.cost ? ( item.cost * item.quantity ).toString() : '0' )}
					</div>
				</div>
			</div>

			{ item.note && (
				<div className={styles.group}>
					<div className={styles.row} style={{ paddingLeft: '6px' }}>
						Note: <span className={styles.value}>{item.note}</span>
					</div>
				</div>
			) }
		</div>
	)
}
